export const phoneLookupKeys = {
	all: ['crm', 'phoneLookup'],
	byNumber: (phoneNumber) => ['crm', 'phoneLookup', phoneNumber],
};
